module.exports = __webpack_public_path__ + "static/media/Mall1959_2.a1501ae9.jpg";